import React from 'react';
import Popover from 'components/shared/popover';
import { RSVP_STATUS } from 'constants/config';

const RSVPPopover = ({
  status,
  changeAttendanceStatus,
  removeAttendance,
  isMultiSession,
  hide,
  setConfirmRsvpModal,
  rsvpHideAlert,
  rsvpType,
}) => {
  const displayPopover = updateStatus => {
    if (rsvpHideAlert || status === null || !isMultiSession) {
      changeAttendanceStatus(updateStatus);
    } else if (
      rsvpType === 'single' &&
      status === 'will_attend' &&
      isMultiSession
    ) {
      changeAttendanceStatus(updateStatus);
    } else {
      setConfirmRsvpModal(true);
    }
  };
  return (
    <Popover
      dismissCallback={hide}
      position="right"
      styleName="AttendanceRSVP--Popover minw-150"
    >
      <div className="fw-b">Change Status</div>
      {status !== RSVP_STATUS.WILL_ATTEND && (
        <button
          type="button"
          onClick={() => displayPopover(RSVP_STATUS.WILL_ATTEND)}
          className="u-resetBtn AttendanceRSVP--PopoverButton"
        >
          {t('in_person_training.attendance.status.accepted')}
        </button>
      )}
      {status !== RSVP_STATUS.WILL_NOT_ATTEND && (
        <button
          type="button"
          onClick={() => displayPopover(RSVP_STATUS.WILL_NOT_ATTEND)}
          className="u-resetBtn AttendanceRSVP--PopoverButton"
        >
          {t('in_person_training.attendance.status.declined')}
        </button>
      )}
      {!isMultiSession && (
        <button
          type="button"
          onClick={removeAttendance}
          className="u-resetBtn AttendanceRSVP--PopoverButton"
        >
          {t('in_person_training.event_overview.attendance.remove_guest')}
        </button>
      )}
    </Popover>
  );
};

export default RSVPPopover;
